.region {
	position: fixed;
	display: flex;
	flex-direction: column-reverse;
	align-items: center;
	gap: var(--lp-spacing-600);
	outline: none;
	z-index: var(--lp-z-index-700);
	pointer-events: none;
}

.bottom {
	bottom: var(--lp-spacing-900);
	left: 0;
	right: 0;
}

.right {
	top: var(--lp-spacing-900);
	right: var(--lp-spacing-900);
}

.toast {
	display: inline-flex;
	font: var(--lp-text-body-1-regular);
	background: var(--lp-color-bg-overlay-secondary);
	color: var(--lp-color-text-ui-primary-base);
	border-radius: var(--lp-border-radius-regular);
	box-shadow:
		0px 0px 1px 0px var(--lp-color-shadow-ui-primary),
		0px 1px 2px 0px var(--lp-color-shadow-ui-primary),
		0px 2px 8px 0px var(--lp-color-shadow-ui-secondary);
	pointer-events: all;
	outline: none;

	& .icon {
		transform: translateY(2px);
	}

	& .info {
		fill: var(--lp-color-fill-feedback-info);
	}

	& .error {
		fill: var(--lp-color-fill-feedback-error);
	}

	& .success {
		fill: var(--lp-color-fill-feedback-success);
	}

	&[data-focus-visible] {
		outline: 2px solid var(--lp-color-shadow-interactive-focus);
		outline-offset: -2px;
		z-index: 1;
	}
}

.default {
	gap: var(--lp-spacing-300);
	padding: var(--lp-spacing-300) var(--lp-spacing-500);
}

.snackbar {
	gap: var(--lp-spacing-400);
	padding: var(--lp-spacing-500);
	width: var(--lp-size-400);

	& [slot='title'] {
		font: var(--lp-text-body-1-semibold);
	}

	& .content {
		gap: var(--lp-spacing-200);
	}
}

/* biome-ignore lint/style/noDescendingSpecificity: ignore */
.content {
	flex: 1;
	display: flex;
	flex-direction: column;

	& [slot='description'] {
		font: var(--lp-text-body-2-regular);

		& a {
			text-decoration: underline;
		}
	}
}
